var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',[_c('div',{staticClass:"terminal-section",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.info))]),_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"terminal-icon"},[_c('i',{class:_vm.icon})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }